import { SearchInput, SelectInput, useGetList } from 'react-admin';
import { ReactElement, useEffect, useState } from 'react';
import { apiUrl } from '../../constants';
import { fetchUtils } from 'react-admin';

const fetchJson = (url: string, options = {}) => {
  const token = localStorage.getItem('auth') as string;
  return fetchUtils.fetchJson(url, {
    ...options,
    user: {
      authenticated: !!token,
      token,
    },
  });
};

export const useGetFilters = () => {
  const [billerCategories, setBillerCategories] = useState<any[]>([]);

  const { data: _billerMerchantCodes = [] } = useGetList('billerMerchantCodes', {
    pagination: { page: 1, perPage: 100 },
  });

  // Transform biller merchant codes to include both id and display value
  const billerMerchantCodes = _billerMerchantCodes.map((mc: any) => ({
    id: mc.merchantCode || mc.id,
    code: mc.merchantCode || mc.merchantId || mc.id,
    details: mc.details || mc.merchantId || mc.id,
  }));

  // Fetch biller categories from API
  useEffect(() => {
    fetchJson(`${apiUrl}/billerCategory`)
      .then(({ json }) => {
        let categories = [];
        if (Array.isArray(json)) {
          categories = json;
        } else if (json.data && Array.isArray(json.data)) {
          categories = json.data;
        }
        setBillerCategories(categories);
      })
      .catch((err) => {
        console.error('Error fetching biller categories:', err);
      });
  }, []);

  return {
    billerCategories,
    billerMerchantCodes,
  };
};

interface FilterProps {
  billerCategories?: any[];
  billerMerchantCodes?: any[];
}

export const billerMappingFilters = ({
  billerCategories = [],
  billerMerchantCodes = [],
}: FilterProps): ReactElement[] => {
  const filters: ReactElement[] = [];

  // Add search input
  filters.push(<SearchInput key="search" source="q" alwaysOn />);

  // Add biller categories filter
  if (billerCategories?.length > 0) {
    filters.push(
      <SelectInput
        key="categoryId"
        source="categoryId"
        label="Biller Category"
        choices={billerCategories}
        optionText="categoryName"
        optionValue="categoryId"
      />
    );
  }

  // Add merchant code filter
  if (billerMerchantCodes?.length > 0) {
    filters.push(
      <SelectInput
        key="merchantCode"
        source="merchantCode"
        label="Merchant Code"
        choices={billerMerchantCodes}
        optionText="details"
        optionValue="id"
      />
    );
  }

  return filters;
};
